import {
    Component,
    OnInit,
    ViewChild,
    ElementRef,
    AfterViewInit,
} from '@angular/core';
import {BsModalEventsEmitter} from 'src/app/modules/shared/events/bsModal.events';
import {AppLoadingEventsEmitter} from '../../../events/loading.events';
import {Router} from '@angular/router';
import {UsersService} from '../../../services/users.service';
import {DailyMealViewModel} from '../../../viewModels/dailyMeal.viewModel';
import {DiaryService} from '../../../services/diary.service';
import {DateService} from '../../../services/date.service';
import {MealViewModel} from '../../../viewModels/meal.viewModel';
import {BsModalRef} from 'ngx-bootstrap';
import {TriggerActionEventsEmitter} from '../../../events/triggerAction.events';

@Component({
    selector: 'app-shortcuts',
    templateUrl: './shortcuts.component.html',
    styleUrls: ['./shortcuts.component.scss']
})
export class ShortcutsComponent implements OnInit, AfterViewInit {
    private readonly mobileWidth: number = 576;

    @ViewChild('wrapper') wrapper: ElementRef<HTMLElement>;

    currentlySelectedDailyMeal: DailyMealViewModel;
    hideAutoLoadRecipes = false;

    constructor(
        public readonly bsModalRef: BsModalRef,
        private readonly appIsLoadingEventsEmitter: AppLoadingEventsEmitter,
        private readonly bsModalEventsEmitter: BsModalEventsEmitter,
        private readonly usersService: UsersService,
        private readonly diaryService: DiaryService,
        private readonly dateService: DateService,
        private readonly triggerActionEventsEmitter: TriggerActionEventsEmitter,
        private readonly router: Router
    ) {
    }

    ngOnInit() {

        this.usersService.getUserProfile().subscribe(profile => {
            this.hideAutoLoadRecipes = profile.hide_auto_load_button;

            this.usersService
                .getUserDailyMeals()
                .subscribe(dailyMeals => {
                    this.diaryService
                        .getDiary(profile.id, this.dateService.getDate())
                        .subscribe(diary => {
                                this.currentlySelectedDailyMeal = dailyMeals.find(dm => dm.id === diary.daily_meals.id);
                            },
                            () => {
                                this.currentlySelectedDailyMeal = this.usersService.userProfile.daily_meals;
                            });
                });
        });
    }

    ngAfterViewInit() {
        if (window.innerWidth <= this.mobileWidth) {
            this.toFullscreen();
        } else {
            this.defaultScreen();
        }
    }

    isBreakfast(title: string): boolean {
        return title === 'Закуска' || title === 'Breakfast';
    }

    isLunch(title: string): boolean {
        return title === 'Обяд' || title === 'Lunch';
    }

    isDinner(title: string): boolean {
        return title === 'Вечеря' || title === 'Dinner';
    }

    isSnack(title: string): boolean {
        return title === '1 intermediate meal' || title === '2 intermediate meal' || title === '3 intermediate meal' || title === 'Първо междинно хранене' || title === 'Второ междинно хранене' || title === 'Трето междинно хранене';
    }

    private toFullscreen() {
        const modalDialog = this.wrapper.nativeElement.parentElement.parentElement.parentElement;
        const modalContent = this.wrapper.nativeElement.parentElement.parentElement;
        const modal = this.wrapper.nativeElement.parentElement;

        modalDialog.style.borderRadius = '0';
        modalDialog.style.display = 'flex';
        modalDialog.style.margin = '0';
        modalDialog.style.padding = '0';
        modalDialog.style.width = '100%';
        modalDialog.style.maxWidth = 'unset';
        modalDialog.style.minHeight = '100%';
        modalDialog.style.height = '100%';
        modalContent.style.borderRadius = '0';
        modal.style.display = 'block';
        modal.style.height = '100%';
    }

    private defaultScreen() {
        const modalDialog = this.wrapper.nativeElement.parentElement.parentElement.parentElement;
        const modal = this.wrapper.nativeElement.parentElement;

        modalDialog.style.borderRadius = '0';
        modalDialog.style.maxWidth = '564px';
        modal.style.display = 'block';
        modal.style.height = '100%';
    }

    onClickMeal(meal: MealViewModel) {
        this.bsModalRef.hide();

        this.router.navigate(['meals']);

        setTimeout(() => {
            this.triggerActionEventsEmitter.broadcastActionChanged({
                'action': 'meal',
                'data': {
                    'meal': meal
                }
            });
        }, 500);
    }

    onClickBasicMealEvent(event: string) {
        this.bsModalRef.hide();

        this.router.navigate(['meals']);

        setTimeout(() => {
            this.triggerActionEventsEmitter.broadcastActionChanged({
                'action': event,
                'data': []
            });
        }, 500);
    }
}
